<!-- este sirve como un popup que termina un arbol de paneles; ya no puede abrir otro -->
<div class="popup">
    <div class="container-detalles panelDetailLocations" [ngClass]="{'expandir': (fullScreen && !mobileQuery.matches)}">
  
      <div *ngIf="!mobileQuery.matches" class="btnClose">
        <mat-icon class="close-button" matTooltip="Cerrar" aria-hidden="false" aria-label="Example home icon" fontIcon="cancel" (click)="CancelButton()"></mat-icon>
      </div>

      <div *ngIf="!mobileQuery.matches" class="arrow-container">
          <mat-icon *ngIf="!fullScreen" (click)="fullScreen = !fullScreen" class="mobile-flecha">keyboard_arrow_up</mat-icon>
          <mat-icon *ngIf="fullScreen" (click)="fullScreen = !fullScreen" class="mobile-flecha">keyboard_arrow_down</mat-icon>
      </div>
      <div class="details-flex">
  
        <!-- Primera sección -->
        <div class="header_panel">
  
           <!-- Componente de lista de reportes (se pasa tentativamente al mismo flex que la barra de herraminetas) -->
           <!-- <div class="btnMenuSecondary">
            <app-report-list [identifier]="locationDTO.identifier" [isDetailLocations]="true"></app-report-list>
           </div> -->
  
            <!-- ? -->
  
            <!-- Botón regresar-->
            <a class="btnReturn" (click)="CancelButton()" matTooltip="Regresar"><mat-icon>arrow_back_ios</mat-icon></a>
  
            <!-- Encabezado -->
            <div *ngIf="true" class="header-background" [ngClass]="{'col-3': !mobileQuery.matches}">
              <img *ngIf="this.locationDTO.icon && !isLoading" [src]="this.locationDTO.panelIcon | findUrl" class="img-car" />
              <ng-container *ngIf="isLoading">
                <div  class="img-car">
                  <ngx-skeleton-loader count="1" appearance="circle" [theme]="{ 'height': '92px', 'width': '98%', 'margin': '2px auto -5px 1px', 'background-color': '#bdbdb9' }">
                  </ngx-skeleton-loader>
                </div>
              </ng-container>
            </div>

            <!-- carrusel -->
            <div *ngIf="false" style="height: 200px;">
              <carousel [images]="images"
                        [isLoading]="isLoadingImages"></carousel>
            </div>
  
            <!-- VIN-->
            <div class="row header-text" [ngClass]="{'col-9': !mobileQuery.matches}">
              <label *ngIf="!mobileQuery.matches" class="header-text-label">Id</label>
              <label class="titlePanel vin-title"> 
                {{ this.locationDTO.identifier }}
                <div class="copy-to-clipboard" (click)="copyToClipboard(locationDTO.identifier)">
                  <mat-icon>content_copy</mat-icon>
                 </div>
              </label>
              
              <label class="subtitlePanel"> {{ getUsableName(this.locationCategoryShortName) }}</label>
              
              <label *ngIf="!mobileQuery.matches" class="header-text-label">Descripción</label>
              <label class="subtitlePanel"> {{this.locationDTO.description}}</label>
            </div>
  
        </div>
        <div class="button-tool-list" *ngIf="(this.images && this.images.length > 0) || isLoadingImages">
          <div class="col-10">
            <location-button-toolbar *ngIf="!isLoading" 
                                      [identifier]="locationDTO.identifier" 
                                      [isDetailLocations]="true" 
                                      [isLoadingParent]="isLoading"
                                      [isMonitor]="false"
                                      [images]="images"
                                      [isLoadingImages]="isLoadingImages"></location-button-toolbar>
          </div>
        </div>
        <!-- seccion de tabs -->
        <div class="tab-group">
          <mat-tab-group [(selectedIndex)]="selectedTabIndex" (selectedTabChange)="selectTab($event)">

            <mat-tab>
              <ng-template mat-tab-label >
                <label  matTooltip="Resumen del Activo" matTooltipPosition="above">
                <mat-icon class="example-tab-icon">info</mat-icon>
                 Detalle Activo 
                </label>
              </ng-template>
              <ng-template matTabContent >
                  <div class="tab-content-wrapper">
                    
                    <!-- primera sección -->
                    <div [ngClass]="{'container': mobileQuery.matches}">
                      <div class="row text-header">
                        <div class="section-header-background">
                          <h2>Datos Generales</h2>
                        </div>
                      </div>
      
                      <!-- datos generales de ingenieros -->
                      <ng-container *ngIf="!this.isLoading">
                        <div class="row row-data">
                          <div class="col-4 d-flex align-items-center">
                            <label class="header_panel titlePanel">Categoría</label>
                          </div>
                          <div class="col-8 d-flex align-items-center">
                            <div class="general-data">{{ getUsableName(this.locationCategoryShortName) }}</div>
                          </div>
                        </div>
                        <div class="row row-data" *ngIf="!!this.locationDTO.group">
                          <div class="col-4 d-flex align-items-center">
                            <label class="header_panel titlePanel">Grupo</label>
                          </div>
                          <div class="col-8 d-flex align-items-center">
                            <div class="general-data">{{ this.locationDTO.group.name }}</div>
                          </div>
                        </div>
                        <div class="row row-data" *ngIf="!!this.locationDTO.subGroup">
                          <div class="col-4 d-flex align-items-center">
                            <label class="header_panel titlePanel">Sub grupo</label>
                          </div>
                          <div class="col-8 d-flex align-items-center">
                            <div class="general-data">{{ this.locationDTO.subGroup.name }}</div>
                          </div>
                        </div>
                      </ng-container>

                       <!-- skeleton de carga -->
                       <ng-container *ngIf="this.isLoading">
                        <div *ngFor="let skel of [1,2,3,4,5,6,7,8,9,10]">
                          <div class="row row-data" [ngClass]="{'background-shade': (skel % 2 == 0)}">
                            <div class="col-4 d-flex align-items-center">
                              <label style="width: 100%; height: 100%;">
                                <ngx-skeleton-loader count="1" appearance="line" [theme]="{ 'border-radius': '8px', 'height': '8px', 'width': '80%', 'margin-bottom': '0px', 'background-color': '#bdbdbd' }"></ngx-skeleton-loader>
                              </label>
                            </div>
                            <div class="col-8 d-flex align-items-center">
                              <label style="width: 100%; height: 100%;">
                                <ngx-skeleton-loader count="1" appearance="line" [theme]="{ 'border-radius': '8px', 'height': '8px', 'width': '80%', 'margin-bottom': '0px' }"></ngx-skeleton-loader>
                              </label>
                            </div>
                          </div>
                        </div>
                       </ng-container>

                    </div>

                  <!-- segunda sección datos del activo-->
                  <div [ngClass]="{'container': mobileQuery.matches}" *ngIf="!isLoading && !!detallesActivo && detallesActivo.length > 0">
                    <div class="row text-header">
                      <div class="section-header-background">
                        <h3>Datos del Activo</h3>
                      </div>
                    </div>
    
                    <div *ngFor="let key of detallesActivo;let i = index" >
                      <div *ngIf="getNameVisibility(key)" class="row row-data" [ngClass]="{'background-shade': (i % 2 == 0)}">
                        <div class="col-4 d-flex align-items-center">
                          <label class="header_panel titlePanel">{{ getUsableName(key) }}</label>
                        </div>
                        <div class="col-8 d-flex align-items-center general-data">
                          <!-- link hardcode, TO DO: pedir una forma de identificar cuál es y cual no referenciador a otro panel -->
                          <div >{{ values[keys.indexOf(key)] }}</div>
                          <!-- <div class="link" *ngIf="key == 'Key'" (click)="openDetailPanel(values[keys.indexOf(key)])">{{ values[keys.indexOf(key)] }}</div> -->
                        </div>
                      </div>  
                    </div>
    
                  </div>
    
                  <!-- tercera sección Datos GPS-->
                  <div [ngClass]="{'container': mobileQuery.matches}" class="lastSection" *ngIf="!isLoading &&!!detallesGPS && detallesGPS.length > 0">
                    <div class="row text-header">
                      <div class="section-header-background">
                        <h3>Datos del GPS</h3>
                      </div>
                    </div>
            
                    <div *ngIf="getNameVisibility('StatusGPS')" class="row row-data background-shade">
                      <div class="col-4 d-flex align-items-center">
                        <label class="header_panel titlePanel">{{ getUsableName('StatusGPS') }}</label>
                      </div>
                      <div class="col-8 d-flex align-items-center general-data">
                        <div>{{ locationDTO.statusGPS }}</div>
                      </div>
                    </div>
            
                    <div *ngFor="let key of detallesGPS;let i = index" >
                      <div *ngIf="getNameVisibility(key)" class="row row-data" [ngClass]="{'background-shade': (i % 2 != 0)}">
                        <div class="col-4 d-flex align-items-center">
                          <label class="header_panel titlePanel">{{ getUsableName(key) }}</label>
                        </div>
                        <div class="col-8 d-flex align-items-center general-data">
                          <div>{{ values[keys.indexOf(key)] }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
  
              </ng-template>
            </mat-tab>
            
            <div *ngFor="let routeSheet of routeSheets; let i = index">
              <mat-tab  class="categoryTabLabel">
                <ng-template mat-tab-label>
                  <!-- <img [src]="routeSheet.category.icon | findUrl" width="30px" class="mr-5">  -->
                  <label matTooltipPosition="above">
                    {{ routeSheet.total }} {{routeSheet.routeSheetName }}
                  </label>
                </ng-template>

                <ng-template matTabContent>
                  <div class="tab-content-wrapper">
                    <div [ngClass]="{'container': mobileQuery.matches}">
                       <!-- asociados  -->
                      <app-route-sheet *ngIf="selectedTabIndex === i+1" [identifier]="this.locationDTO.identifier" 
                                                                        [childCategory]="routeSheet.routeSheetIdLocationCategory"
                                                                        [parentCategory]="this.locationDTO.idLocationCategory"
                                                                        [parentCoordX]="this.locationDTO.cordsX"
                                                                        [parentCoordY]="this.locationDTO.cordsY"
                                                                        (categoryTotal)="loadTotal($event, routeSheet)">
                      </app-route-sheet>
                    </div>
                  </div>
                </ng-template>
              </mat-tab>
            </div>
          </mat-tab-group>
        </div>
      </div>  
  
    </div>
  </div>